import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import Pagination from "react-js-pagination";
import {Config} from '../../../Config'
import Select from 'react-select'

export default function CampaignTemplate() {
    const roles = new Role();
    //region search
    let btnTextDefault = 'ค้นหา';
    let btnTextLoading = 'กำลังค้นหา..';
    let [showSearch, setShowSearch] = React.useState(false);
    let [itemPerpage, setItemPerpage] = React.useState(10);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);
    let [typeId, setTypeId] = React.useState(null);
    let [name, setName] = React.useState(null);
    let [sortField, setSortField] = React.useState(null);
    let [sortType, setSortType] = React.useState(null);

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [type, setType] = React.useState('');

    React.useEffect(() => {
        getData({
            typeId: null,
            name : null,
            startDate : null,
            endDate : null,
            createdBy: null
        });

        (async function() {
            try {
                const resType = await Utils.getType();
                setType(resType);
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onSearch = (e) => {
        e.preventDefault();
        getData({
            name: e.target.elements.name.value,
            typeId : typeId != null ? typeId.id : null,
            sortField : e.target.elements.sortField.value,
            sortType : e.target.elements.sortType.value
        });
        setName(e.target.elements.name.value);
        setTypeId(typeId);
        setSortField(e.target.elements.sortField.value);
        setSortType(e.target.elements.sortType.value);
    };
    const onSearchReset = () => {
        setName('');
        setTypeId(null);
        setSortField(null);
        setSortType(null);
        setActivePage(0);
        getData({
            name : null,
            typeId : null,
            sortField: null,
            sortType: null,
            activePage: 1
        });
    };
    const onChangeName = (value) => setName(value);
    const onChangeType = (obj) => setTypeId(obj);
    const onChangeSortField = (Id) => setSortField(Id);
    const onChangeSortType = (Id) => setSortType(Id);
    const onPageChange = (pageNum) => {
        setActivePage(pageNum);
        getData({
            name : name ?? null,
            typeId : typeId != null ? typeId.id : null,
            sortField: sortField ?? null,
            sortType: sortType ?? null,
            activePage: pageNum,
        });
    };
    //endregion

    const getData = (params) => {
        setLoading(true);
        if(params.itemPerpage) {
            itemPerpage = params.itemPerpage;
        }
        fetch(Config.url.API_URL +'/api/campaignTemplate/listing', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                name: params.name ?? null,
                typeId: params.typeId ?? null,
                sortField: params.sortField ?? null,
                sortType: params.sortType ?? null,
                itemPerpage: itemPerpage,
                startItem: params.activePage > 1 ? (params.activePage*itemPerpage)-itemPerpage : 0,
                agencyId: roles.permissionId === Utils.SUPER_ADMIN_ID ? null : roles.agencyId
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setCountAllItem(result.count);
            setTotalPage(result.count > 0 ? (result.count / itemPerpage) : 1);
            setData(result.rows);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const onChangeItemPerpage = (e) => {
        setItemPerpage(e.target.value);
        setActivePage(1);
        getData({
            name : name ?? null,
            typeId : typeId != null ? typeId.id : null,
            sortField: 'id',
            sortType: 'DESC',
            activePage: 1,
            itemPerpage: e.target.value
        });
    };

    function showAgency(items) {
        if(items) {
            let result = [];
            items.map(item => {
                if(item.data) {
                    result.push(item.data.name);
                }
            });
            return result.join(', ');
        }
        else {
            return '-';
        }
    }

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Campaign Template</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    {roles.isCreate(Utils.MENU_CAMPAIGN_TEMPLATE) ? (
                        <NavLink className="btn btn-sm btn-primary" to='/campaignTemplate/create'><span><Icon.PlusLg/> เพิ่มข้อมูล</span></NavLink>
                    ) : ''}
                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
                <>
                    <div className="bg-light border rounded my-2">
                        <button type="button" className="btn btn-light w-100 text-start" onClick={() => {setShowSearch(!showSearch)}}><Icon.Search/> ค้นหา | เรียงลำดับ</button>
                        <div className={showSearch ? 'd-block p-3':'d-none'}>
                            <form className="row g-3" onSubmit={onSearch} onReset={onSearchReset}>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input type="text" className="form-control" id="name" value={name ?? ''} onChange={(event) => onChangeName(event.target.value)}  maxLength={100} />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="typeId" className="form-label">Type</label>
                                    <Select
                                        classNamePrefix="form-select-search"
                                        options={type}
                                        onChange={(event) => onChangeType(event)}
                                        defaultValue={typeId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                                <div className="col-12 col-sm-6">
                                    <label htmlFor="sortField" className="form-label">เรียงลำดับ</label>
                                    <div className="row">
                                        <div className="col-8">
                                            <select className="form-select" id="sortField" onChange={(event) => onChangeSortField(event.target.value)} value={sortField ?? ''}>
                                                <option value="id">Id</option>
                                                <option value="type">Type</option>
                                            </select>
                                        </div>
                                        <div className="col-4">
                                            <select className="form-select" id="sortType" onChange={(event) => onChangeSortType(event.target.value)} value={sortType ?? ''}>
                                                <option value="DESC">DESC</option>
                                                <option value="ASC">ASC</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="btn btn-primary">{isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <button type="reset" className="btn btn-light border ms-2">รีเซ็ต</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                        <>
                            <div className="table-container shadow">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th className="w80 text-center">#</th>
                                        <th>ชื่อ Campaign Template</th>
                                        <th className="text-center">Agency</th>
                                        <th className="w100">Type</th>
                                        <th className="w100 text-center">สถานะ</th>
                                        <th className="w100 text-center">วันที่สร้าง</th>
                                        <th className="w100 text-center">วันที่อัพเดต</th>
                                        <th className="w100 text-center">เครื่องมือ</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data.map((row, index) => {
                                        return (
                                            <tr key={index} id={"rowId" + row.id}>
                                                <td className="text-center">{row.id}</td>
                                                <td>{row.name}</td>
                                                <td>{showAgency(row.items)}</td>
                                                <td>{Utils.generateUTMType(row.typeId)}</td>
                                                <td className="text-center">
                                                    <div className="form-check form-switch">
                                                        <input className="form-check-input float-none" type="checkbox" name="statusChecked" id="status" checked={row.status===1} onChange={(e) => Utils.onStatusClick(e, row, data, setData, 'campaignTemplate')} />
                                                        <label className="form-check-label" htmlFor="status">

                                                        </label>
                                                    </div>
                                                </td>
                                                <td className="text-center">{Utils.dateTime(row.createdAt)}</td>
                                                <td className="text-center">{Utils.dateTime(row.updatedAt)}</td>
                                                <td className="text-center">
                                                    {roles.isEdit(Utils.MENU_CAMPAIGN_TEMPLATE) ? (
                                                        <Link className="btn btn-sm btn-light mx-1" to={'/campaignTemplate/edit/' + Utils.encodeItem({id: row.id,  createdAt: row.createdAt})}><Icon.Pencil/></Link>
                                                    ) : ''}
                                                    {roles.isDelete(Utils.MENU_CAMPAIGN_TEMPLATE) ? (
                                                        <button className="btn btn-sm btn-light mx-1" onClick={() => Utils.deleteItem('campaignTemplate', row.id, row.name)}><Icon.Trash/></button>
                                                    ) : ''}
                                                </td>
                                            </tr>
                                        );
                                    })
                                    }
                                    </tbody>
                                </table>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 col-sm-4 mt-2 mt-sm-0 text-end align-self-center">
                                    <select className="form-select w100" id="itemPerpage" onChange={(e) => onChangeItemPerpage(e)} value={itemPerpage}>
                                        <option value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                                <div className="col-12 col-sm-8">
                                    <div className={totalPage > 1 ? 'my-3':'d-none'}>
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            innerClass="pagination justify-content-sm-end"
                                            activePage={activePage}
                                            itemsCountPerPage={itemPerpage}
                                            totalItemsCount={countAllItem}
                                            pageRangeDisplayed={5}
                                            onChange={(pageNum) => onPageChange(pageNum)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </>
            }
        </main>
    );
} 